import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Drifting pastel mesh — 5 blurred pastel blobs rendered with CSS gradients
 * and animated via the `ww-drift*` keyframes defined in tokens.css.
 *
 * Absolutely positioned, fixed, behind all content (`z-index: -1`).
 * Honours `prefers-reduced-motion` automatically (the keyframes are killed
 * by the global media query in tokens.css).
 *
 * Rendered once inside <AppShell /> — do not nest or duplicate it; the
 * `.mesh` class assumes a single layer of blobs on the page.
 */
export function MeshBackground() {
    return (_jsxs("div", { className: "mesh", "aria-hidden": true, children: [_jsx("div", { className: "blob b1" }), _jsx("div", { className: "blob b2" }), _jsx("div", { className: "blob b3" }), _jsx("div", { className: "blob b4" }), _jsx("div", { className: "blob b5" })] }));
}
